module.exports = __webpack_public_path__ + "static/media/netflix.897f8034.png";